import { render, staticRenderFns } from "./LoaderSquare.vue?vue&type=template&id=ab946814&scoped=true&"
import script from "./LoaderSquare.vue?vue&type=script&lang=js&"
export * from "./LoaderSquare.vue?vue&type=script&lang=js&"
import style0 from "./LoaderSquare.vue?vue&type=style&index=0&id=ab946814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab946814",
  null
  
)

export default component.exports